'use client';
import { useState, useEffect, useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import service from "@/services/service";
import { useAuth } from '@/contexts/AuthContext';

export const Header = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
  	const { isLoggedIn, userProfile, logout } = useAuth(); // 使用AuthContext
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);
	const [isUserHovered, setIsUserHovered] = useState(false); // 新状态用于追踪悬停状态
	const pathname = usePathname();

	const navItems = [
		{ path: "/stocks", label: "Stocks" },
		// 暂时先注掉： { path: "/options", label: "Options" },
		{ path: "/stock-themes", label: "Themes" },	
		{ path: "/marketcap-ranking/latest", label: "Market Cap Ranking" },
		{ path: "/trading-strategies", label: "Trading Strategies" },
		{ path: "/sec-filings-tldr", label: "SEC Filings TLDR" },
		{ path: "/analysis-reports", label: "Analysis Reports" },
		//{ path: "/about-us", label: "About Us" },
	];

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);


	const handleGoogleLogin = async () => {
		// 获取 google auth url
		try {
			const response: any = await service.get('api/get_google_auth_url');
			console.log('Google auth URL:', response);
			const authUrl = response.url;
			window.location.href = authUrl;
		} catch (error) {
			console.error('获取 Google 登录 URL 失败:', error);
			alert('登录失败，请稍后再试。');
		}

	}

	const handleLogout = () => {
		localStorage.removeItem('jwt');
		localStorage.removeItem('user_profile');
		logout(); // 调用上下文中的logout方法
	};
	
  
	

  	return (
		<header className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50">
			<nav className="container mx-auto px-4 py-4">
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						<Link href="/">
							<Image
								src="/images/trade_fomo_logo.png"
								alt="TradeFomo Logo" 
								height={80}
								width={250}
								className="h-15s w-auto cursor-pointer"
							/>
						</Link>
					</div>

					{/* 桌面导航 */}
					<div className="hidden md:flex flex-grow flex-wrap justify-center space-x-4 2xl:space-x-8 items-center h-full mx-4">
						{navItems.map(item => (
							<Link 
								key={item.path}
								href={item.path}
								className={`text-base lg:text-lg font-semibold py-2 transition-colors whitespace-nowrap ${
									pathname === item.path 
										? "text-primary border-b-2 border-primary" 
										: "text-gray-500 hover:text-primary"
									}`}
							>
							{item.label}
							</Link>
						))}
					</div>

					{/* 桌面端登录/注销按钮 */}
					<div className="flex-shrink-0"> 
						{isLoggedIn ? (
						<div className="relative flex items-center space-x-4">
							{userProfile && (
							<div 
								className="relative group" // 新增group类
								onMouseEnter={() => {
									if (timeoutRef.current) clearTimeout(timeoutRef.current);
									setIsUserHovered(true);
								}}
								onMouseLeave={() => {
									// 延迟300ms关闭
									timeoutRef.current = setTimeout(() => {
										setIsUserHovered(false);
									}, 300);
								}}
							>
								<div className="flex items-center cursor-pointer">
									<img 
										src="/images/user_profile.svg"
										alt="User" 
										className="w-6 h-6 rounded-full mr-2" 
									/>
									<span className="text-sm font-medium">{userProfile!.userName}</span>
								</div>
								{/* 只在悬停时显示登出按钮 */}
								{isUserHovered && (
									<div 
										className="absolute top-full mt-2 right-0 bg-white border border-gray-200 shadow-lg rounded-md z-50"
										onMouseEnter={() => {
											if (timeoutRef.current) clearTimeout(timeoutRef.current);
										}}
										onMouseLeave={() => setIsUserHovered(false)}
									>
										<button 
											onClick={handleLogout}
											className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
										>
											Log out
										</button>
									</div>
								)}
							</div>)}
						</div>) : 
						(
						<button 
							onClick={handleGoogleLogin}
							className="bg-black text-white 
										py-2 px-8 rounded-lg 
										font-semibold 
										hover:bg-opacity-90 
										transition-colors
										whitespace-nowrap"
						>
							Sign in
						</button>)}

						{/* 移动端菜单按钮 */}
						<button
							aria-label={isMenuOpen ? "关闭菜单" : "打开菜单"}
							aria-expanded={isMenuOpen}
							className="md:hidden text-foreground self-center"
							onClick={() => setIsMenuOpen(!isMenuOpen)}
						>
							<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
							</svg>
						</button>
					</div>
				</div>

				{/* 移动端导航菜单 */}
				{isMenuOpen && (
				<div className="md:hidden absolute top-full left-0 right-0 bg-card border-b border-border shadow-lg">
					<div className="container mx-auto px-4 py-3 flex flex-col space-y-3">
					{navItems.map(item => (
						<Link 
							key={item.path}
							href={item.path}
							className={`py-2 text-lg font-semibold ${
								pathname === item.path 
								? "text-primary" 
								: "text-gray-500 hover:text-primary"
							}`}
							onClick={() => setIsMenuOpen(false)}
						>
							{item.label}
						</Link>
					))}
					</div>
				</div>
				)}
			</nav>
		</header>
	);
};